import { useTranslations } from 'next-intl'
import { Badge } from '@repo/web-ui/components/badge/badge'

import type { ProductCardProductEnrolled } from '../../_hooks/product-card-product-type'

const getLevelVariant = (level?: string) => {
  if (!level) {
    return 'green'
  }

  switch (level.toLowerCase()) {
    case 'beginner': {
      return 'green'
    }
    case 'intermediate': {
      return 'yellow'
    }
    case 'advanced': {
      return 'red'
    }
    default: {
      return 'green'
    }
  }
}

export const LevelBadge = ({ level }: { level: ProductCardProductEnrolled['level'] }) => {
  const t = useTranslations('components.product_box.level')

  if (!level) {
    return null
  }

  return (
    <Badge className="absolute bottom-2 left-2" variant={getLevelVariant(level)}>
      {t(level)}
    </Badge>
  )
}
